import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Admin imports (existing - unchanged)
import Sidebar from './Admin/Sidebar';
import Dashboard from './Admin/Components/Dashboard';
import BannerMaster from './Admin/Components/BannerMaster';
import TeamMaster from './Admin/Components/TeamMaster';
import AboutUsMaster from './Admin/Components/AboutUsMaster';
import TestimonialMaster from './Admin/Components/TestimonialMaster';
import FooterMaster from './Admin/Components/FooterMaster';

// User Layout and Components
import UserLayout from './User/Layout/UserLayout';
import AboutUs from './User/Components/AboutUs';
import Home from './User/Components/Home';
import Team from './User/Components/Team';
import Testimonials from './User/Components/Testimonials';
import Contact from './User/Components/Contact';
import Portfolio from './User/Components/Portfolio';
import WebDevelopment from './User/Components/WebDevelopment';
import Cybersecurity from './User/Components/CyberSecurity';
import DigitalMarketingPage from './User/Components/DigitalMarketingPage';
import ScrollTop from './User/ScrollTop';
function App() {
  return (
    <Router>
  <ScrollTop/>
      <Routes>
        {/* User Routes with Layout */}
        <Route path="/" element={<UserLayout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<AboutUs />} />
          <Route path="team" element={<Team />} />
          <Route path="testimonials" element={<Testimonials />} />
          <Route path="contact" element={<Contact />} />
          <Route path="portfolio" element={<Portfolio />} />
          <Route path="/web-development" element={<WebDevelopment />} />
          <Route path="/cybersecurity" element={<Cybersecurity />} />
          <Route path="/digital-marketing" element={< DigitalMarketingPage/>} />
          

        </Route>

        {/* Admin Routes (existing - unchanged) */}
        <Route path="/admin" element={<Sidebar />}>
          <Route index element={<Dashboard />} />
          <Route path="banner" element={<BannerMaster />} />
          <Route path="team" element={<TeamMaster />} />
          <Route path="about" element={<AboutUsMaster />} />
          <Route path="footer" element={<FooterMaster />} />
          <Route path="testimonial" element={<TestimonialMaster />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;